import { Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { formatDate, formatMoney } from "@/features/shared";

import {
  expenseAccrualPaymentStatusColors,
  expenseAccrualPaymentStatusLabels,
} from "../../payment-status";

export const GeneralInformationSection = ({ expenseAccrual }) => {
  const payableAccount = expenseAccrual.expensePayableOutletChartOfAccount;

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Stack
            direction="row"
            spacing={1.5}
            sx={{ alignItems: "center" }}
          >
            <Typography variant="subtitle1">Informasi Umum</Typography>
            {expenseAccrual.status && (
              <Chip
                size="small"
                label={
                  expenseAccrualPaymentStatusLabels[expenseAccrual.status] ??
                  expenseAccrual.status
                }
                color={
                  expenseAccrualPaymentStatusColors[expenseAccrual.status] ??
                  "default"
                }
              />
            )}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Tanggal
          </Typography>
          <Typography variant="body1">
            {formatDate(expenseAccrual.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Jatuh Tempo
          </Typography>
          <Typography variant="body1">
            {formatDate(expenseAccrual.dueDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Hutang Beban
          </Typography>
          <Typography variant="body1">
            {payableAccount
              ? `${payableAccount.code} - ${payableAccount.name}`
              : "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total
          </Typography>
          <Typography variant="body1">
            {formatMoney(expenseAccrual.amount || 0)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Terbayar
          </Typography>
          <Typography variant="body1">
            {formatMoney(expenseAccrual.paidAmount || 0)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Sisa
          </Typography>
          <Typography variant="body1">
            {formatMoney(expenseAccrual.outstanding || 0)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Catatan
          </Typography>
          <Typography variant="body1">{expenseAccrual.note || "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  expenseAccrual: PropTypes.object.isRequired,
};
